<template>
    <md-card v-if="cart">
        <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="md-layout md-gutter">
                <div class="md-layout-item">
                    <div class="card-icon">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'check-circle']" />
                    </div>
                    <h4 class="title">Interventions sélectionnées</h4>
                </div>
            </div>
        </md-card-header>
        <md-card-content>
            <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-70">
                    <p class="font-medium">Panier</p>
                    <template v-if="cart.interventions.length">
                        <div class="travel-time-background travel-transparent px-3">
                            <div class="md-layout md-gutter">
                                <div class="md-layout-item md-size-20">
                                    <div class="flex items-center h-full">
                                        <font-awesome-icon :icon="['fa', 'car-alt']"></font-awesome-icon>
                                        <strong class="px-3">Informations trajet initial</strong>
                                    </div>
                                </div>
                                <div class="md-layout-item md-size-20">
                                    <div class="md-vdatepicker">
                                        <datetime v-model="firstTravelDuration" type="time" auto :phrases="{ ok: 'Confirmer', cancel: 'Annuler' }" :class="{'md-disabled':cart.hasFixedInterventions}"
                                                  input-id="duration" placeholder="00:00" :minute-step="5" :disabled="cart.hasFixedInterventions"
                                        >
                                            <label slot="before">Trajet initial (modifié)</label>
                                        </datetime>
                                    </div>
                                </div>
                                <div class="md-layout-item md-size-60">
                                    <md-field>
                                        <label>Commentaire</label>
                                        <md-input v-model="cart.firstTravel.comment" @keyup.enter="$emit('update-cart-settings', cart)"></md-input>
                                    </md-field>
                                </div>
                            </div>
                        </div>
                        <div class="cart-row no-shadow mb-0">
                            <div class="md-layout travel-time-background text-white px-3">
                                <div class="md-layout-item md-size-60">
                                    <font-awesome-icon :icon="['fa', 'car-alt']"></font-awesome-icon>
                                    <span class="px-3 font-medium">Trajet initial (modifié) : {{ hoursAndMinutes(cart.firstTravel.calculatedDuration) }} ({{ hoursAndMinutes(cart.firstTravel.duration) }})</span>
                                </div>
                                <div class="md-layout-item md-size-5 flex justify-center items-center">
                                    <span class="font-medium">{{ cart.firstTravel.departureTime }}</span>
                                </div>
                            </div>
                        </div>
                        <div v-for="(intervention, key) in cart.interventions" :key="key" class="cart-row" :class="{'first': key === 0}">
                            <div class="md-layout travel-time-background text-white px-3" v-if="key !== 0 && intervention.isUpdatable && ((intervention.intervention.latitude !== cart.interventions[key - 1].intervention.latitude) || (intervention.intervention.longitude !== cart.interventions[key - 1].intervention.longitude))">
                                <div class="md-layout-item md-size-60">
                                    <font-awesome-icon :icon="['fa', 'car-alt']"></font-awesome-icon>
                                    <span class="px-3 font-medium">Trajet intermédiaire : {{ hoursAndMinutes(intervention.timeFrom) }}</span>
                                </div>
                                <div class="md-layout-item md-size-5 flex justify-center items-center">
<!--                                    <span class="badge badge-info">{{ hoursAndMinutes(intervention.intervention.duration) }}</span>-->
                                    <span class="font-medium">{{ intervention.travelStartTime }}</span>
                                </div>
                            </div>
                            <div class="md-layout md-gutter items-center py-2" :class="!intervention.isUpdatable ? 'disabled-row' : ''">
                                <div class="md-layout-item md-size-5" style="padding-left: 10px;">
                                    <div class="flex justify-around items-center" v-if="intervention.isUpdatable">
                                        <md-button v-if="key !== 0 && cart.interventions[key - 1].isUpdatable" class="md-icon-button md-small-icon md-rounded-icon my-0"
                                                   @click="moveUp(intervention)">
                                            <font-awesome-icon class="md-icon" :icon="['fa', 'caret-up']" />
                                        </md-button>
                                        <md-button v-if="key !== cart.interventions.length - 1" class="md-icon-button md-small-icon md-rounded-icon my-0"
                                                   @click="moveDown(intervention)">
                                            <font-awesome-icon class="md-icon" :icon="['fa', 'caret-down']" />
                                        </md-button>
                                    </div>
                                </div>
                                <div class="md-layout-item md-size-20">
                                    <div class="leading-none mb-0.5 font-normal">{{ intervention.intervention.client_num }}</div>
                                    <div class="text-2xs leading-none">{{ intervention.intervention.client_name }}</div>
                                </div>
                                <div class="md-layout-item md-size-35">
                                    <div class="leading-none mb-0.5 font-medium">{{ intervention.intervention.site_name }}</div>
                                    <div class="text-2xs leading-none">{{ intervention.intervention.sector_name ? intervention.intervention.sector_name : 'Ø' }} - {{ intervention.intervention.city }}</div>
                                </div>
                                <div class="md-layout-item md-size-5 flex justify-center">
                                    <span class="badge badge-info">{{ intervention.startTime }}</span>
                                </div>
                                <div class="md-layout-item md-size-5 flex justify-center">
                                    <span class="badge badge-danger">{{ hoursAndMinutes(intervention.intervention.duration) }}</span>
                                </div>
                                <div class="md-layout-item md-size-25">
                                    <span class="text-sm">{{ intervention.intervention.intervention_type }}</span>
                                </div>
                                <div class="md-layout-item md-size-5" style="padding-right: 15px;">
                                    <div class="flex items-center justify-around">
                                        <md-button class="md-icon-button md-small-icon md-rounded-icon my-0"
                                                   :disabled="cart.hasFixedInterventions"
                                                   :class="intervention.lunchBreak ? 'md-success' : 'md-default'"
                                                   @click="updateLunchBreakStatus(intervention)">
                                            <font-awesome-icon class="md-icon" :icon="['fa', 'utensils']"/>
                                        </md-button>
                                        <div class="ml-1" v-if="intervention.isUpdatable">
                                            <md-button class="md-icon-button md-small-icon md-rounded-icon my-0 md-danger"
                                                       @click="removeFromCart(intervention)">
                                                    <font-awesome-icon class="md-icon" :icon="['fa', 'times']" />
                                            </md-button>
                                            <md-tooltip md-direction="top">Retirer du panier</md-tooltip>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="md-layout travel-time-background last text-white px-3">
                            <div class="md-layout-item md-size-60">
                                <font-awesome-icon :icon="['fa', 'car-alt']"></font-awesome-icon>
                                <span class="px-3 font-medium">Trajet final (modifié) : {{ hoursAndMinutes(cart.lastTravel.calculatedDuration) }} ({{ hoursAndMinutes(cart.lastTravel.duration) }})</span>
                            </div>
                            <div class="md-layout-item md-size-5 flex justify-center items-center">
                                <span class="font-medium">{{ cart.lastTravel.departureTime }}</span>
                            </div>
                        </div>
                        <div class="travel-time-background travel-transparent px-3 mt-2">
                            <div class="md-layout md-gutter">
                                <div class="md-layout-item md-size-20">
                                    <div class="flex items-center h-full">
                                        <font-awesome-icon :icon="['fa', 'car-alt']"></font-awesome-icon>
                                        <strong class="px-3">Informations trajet final</strong>
                                    </div>
                                </div>
                                <div class="md-layout-item md-size-20">
                                    <div class="md-vdatepicker">
                                        <datetime v-model="lastTravelDuration" type="time" auto :phrases="{ ok: 'Confirmer', cancel: 'Annuler' }" :class="{'md-disabled':cart.hasFixedInterventions}"
                                                  input-id="duration" placeholder="00:00" :minute-step="5" :disabled="cart.hasFixedInterventions"
                                        >
                                            <label slot="before">Trajet final(modifié)</label>
                                        </datetime>
                                    </div>
                                </div>
                                <div class="md-layout-item md-size-60">
                                    <md-field>
                                        <label>Commentaire</label>
                                        <md-input v-model="cart.lastTravel.comment" @keyup.enter="$emit('update-cart-settings', cart)"></md-input>
                                    </md-field>
                                </div>
                            </div>
                        </div>
                        <div class="md-layout md-gutter mt-1 px-3 md-alignment-center-right">
                            <div class="md-layout-item md-size-20">
                                <div class="flex items-center">
                                    <font-awesome-icon :icon="['fa', 'utensils']"/>
                                    <div class="px-3">
                                        <span class="font-medium uppercase">Temps de pause :</span>
                                        <span class="ml-1">{{ hasLunchBreak ? '1' : '0' }}h00</span>
                                    </div>
                                </div>
                            </div>
                            <div class="md-layout-item md-size-25">
                                <div class="flex items-center">
                                    <font-awesome-icon :icon="['fa', 'car-alt']"/>
                                    <div class="px-3 flex items-center">
                                        <span class="font-medium uppercase">Temps de trajet :</span>
                                        <div class="ml-1">
                                            <span>{{ totalTravelTime.intervention }}</span>
                                            <span class="text-primary ml-1">(+{{ totalTravelTime.technician }})</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="md-layout-item md-size-20">
                                <span class="badge badge-info">TOTAL DES HEURES : {{ totalInterventionDuration }}</span>
                            </div>
                        </div>
                    </template>
                    <span v-else-if="!cartIsReady">
                        Sélectionnez un utilisateur et une date pour pouvoir remplir le panier
                    </span>
                </div>
                <div class="md-layout-item md-size-15 border-l">
                    <div class="px-2">
                        <p class="font-medium">Journée prévue</p>
                        <div v-if="computedAbsences" class="scheduled-day-absence leading-4" :class="classComputedAbsences">
                            <span class="text-xs leading-none font-medium">Absence prévue : {{ computedAbsences }}</span>
                        </div>
                        <div v-if="computedMeetings" class="scheduled-day-absence bg-absence-7 leading-4 mt-1">
                            <span class="text-xs leading-none font-medium">Réunion prévue : {{ computedMeetings }}</span>
                        </div>
                        <div v-if="plannedDay.plannings && plannedDay.plannings.length > 0" class="px-0.5">
                            <div class="flex justify-start items-center">
                                <span class="text-xs leading-none font-medium">Interventions prévues</span>
                                <div  v-if="plannedDay.hasConflict">
                                    <span class="conflict">
                                        <font-awesome-icon class="md-icon text-danger ml-2" :icon="['fa', 'exclamation-circle']" />
                                    </span>
                                    <md-tooltip md-direction="top">Interventions en conflit</md-tooltip>
                                </div>
                            </div>
                            <ul>
                                <li v-for="(row, key) in plannedDay.plannings" :key="key" class="scheduled-day-row mt-0.5">
                                    <div class="flex items-center space-x-2">
                                        <font-awesome-icon class="md-icon mx-0 text-primary" :icon="['fa', 'car-alt']" v-if="row.element && row.element.is_deplacement"/>
                                        <font-awesome-icon class="md-icon mx-0 text-info" :icon="['fa', 'utensils']" v-else-if="row.element && row.element.is_pause"/>
                                        <font-awesome-icon class="md-icon mx-0 text-gray" :icon="['fa', 'list-alt']" v-else-if="row.intervention"/>

                                        <span class="font-medium">{{ $moment(row.start_date).format('HH : mm') }}</span>
                                        <font-awesome-icon class="md-icon mx-0 text-gray" :icon="['fa', 'caret-right']"/>
                                        <span class="font-medium">{{ $moment(row.end_date).format('HH : mm') }}</span>
                                    </div>

                                    <div v-if="row.hasTravel" class="flex items-center justify-between mt-0.5">
                                        <div class="flex items-center space-x-2">
                                            <font-awesome-icon class="md-icon mx-0 text-primary" :icon="['fa', 'car-alt']"/>
                                            <span class="font-medium">{{ $moment(row.end_date).format('HH : mm') }}</span>
                                            <font-awesome-icon class="md-icon mx-0 text-gray" :icon="['fa', 'caret-right']"/>
                                            <span class="font-medium">{{ $moment(plannedDay.plannings[key + 1].start_date).format('HH : mm') }}</span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div v-else>
                            <span class="text-xs leading-none font-medium">Pas d'interventions prévues</span>
                        </div>
                    </div>
                </div>
                <div class="md-layout-item md-size-15 border-l">
                    <div class="pl-2">
                        <p class="font-medium">Configuration du panier</p>
                        <div class="md-vdatepicker">
                            <datetime v-model="departureTime" type="time" auto :phrases="{ ok: 'Confirmer', cancel: 'Annuler' }" :class="{'md-disabled':cart.hasFixedInterventions}"
                                      input-id="duration" :minute-step="5" :disabled="cart.hasFixedInterventions"
                            >
                                <label slot="before">Heure de la première intervention</label>
                            </datetime>
                        </div>
                        <div class="md-vdatepicker">
                            <datetime v-model="date" type="date" auto :phrases="{ ok: 'Confirmer', cancel: 'Annuler' }"
                                      input-id="duration" :minute-step="5" value-zone="Europe/Paris"
                            >
                                <label slot="before">Date</label>
                            </datetime>
                        </div>
                        <div class="md-multiselect">
                            <label>Technicien</label>
                            <multiselect
                                v-model="technician"
                                :options="technicians"
                                label="full_name"
                                track-by="id"
                                placeholder="Technicien"
                                :show-labels="false">
                                <template slot="noOptions">La liste est vide</template>
                                <template slot="noResult">Aucun élement correspondant</template>
                            </multiselect>
                        </div>
                        <div class="text-xs font-normal leading-none italic mb-2">Attention, modifier le technicien ou la date écrase le contenu du panier.</div>
                        <div class="flex justify-end">
                            <md-button class="md-icon-button md-raised md-success" :disabled="!cartIsReady || (cart.interventions.length === 0) || dateIsSunday" @click="storeCart">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'check-circle']" />
                                <span class="leading-none font-medium ml-2">Valider le panier</span>
                            </md-button>
                        </div>
                    </div>
                </div>
            </div>
        </md-card-content>
    </md-card>
</template>

<script>
import dateTimeFormattingMixin from '@/mixins/date-time-formatting-mixin'

export default {
    name: "ManagementCart",
    props: {
        cart: Object,
        technicians: Array,
        cartIsReady: Boolean,
        plannedDay: Object
    },
    mixins: [ dateTimeFormattingMixin ],
    methods: {
        async getSiteInformation(id) {
            this.$emit('updating')
            const { data } = await this.$store.dispatch('sites/getSiteInformation', { siteId: id })
            this.siteInformationModal.data = data
            this.siteInformationModal.data.schedules = this.formatSchedules(this.siteInformationModal.data.schedules)
            this.$emit('loaded')
        },
        goToRoute(route, params = null) {
            this.$router.push({ name: route, params })
        },
        formatDuration(duration) {
            const hours = Math.floor(duration / 60)
            const minutes = duration - (hours * 60)
            return this.$moment(new Date().setHours(hours, minutes)).format('HH:mm')
        },
        moveUp(intervention) {
            this.$emit('updating')
            const position = intervention.position
            this.cart.interventions.forEach((item) => {
                if(item.position === position) {
                    item.position = (item.position - 1)
                } else if(item.position === (position - 1)){
                    item.position = (item.position + 1)
                }
            })
            this.cart.interventions.sort((a, b) => a.position - b.position)
            this.$emit('update-cart-settings', this.cart)
        },
        moveDown(intervention) {
            this.$emit('updating')
            const position = intervention.position
            this.cart.interventions.forEach((item) => {
                if(item.position === position) {
                    item.position = (item.position + 1)
                } else if(item.position === (position + 1)){
                    item.position = (item.position - 1)
                }
            })
            this.cart.interventions.sort((a, b) => a.position - b.position)
            this.$emit('update-cart-settings', this.cart)
        },
        removeFromCart(intervention) {
            this.$emit('updating')
            this.cart.interventions = this.cart.interventions.filter(item => item.position !== intervention.position)
            this.cart.interventions.forEach((item) => {
                if(item.position > intervention.position) {
                    item.position--
                }
            })
            this.$emit('update-cart-settings', this.cart)
        },
        updateLunchBreakStatus(intervention) {
            this.cart.interventions.forEach((item) => {
                if(item.position === intervention.position && !intervention.lunchBreak) {
                    item.lunchBreak = true
                } else {
                    item.lunchBreak = false
                }
            })
            this.$emit('update-cart-settings', this.cart)
        },
        async storeCart() {
            this.$emit('updating')
            try {
                await this.$store.dispatch('planningManagement/storeCart', { cart: this.cart })
                this.$emit('reset-cart', this.cart)
            } catch {

            }
        },
    },
    computed: {
        firstTravelDuration: {
            get() {
                if (this.cart && this.cart.firstTravel.duration) {
                    return this.formatDuration(this.cart.firstTravel.duration)
                }
                return ''
            },
            set(val) {
                if (val) {
                    this.cart.firstTravel.duration = parseInt(this.$moment(val).format('HH')) * 60 + parseInt(this.$moment(val).format('mm'))
                    this.$emit('update-cart-settings', this.cart)
                }

            }
        },
        lastTravelDuration: {
            get() {
                if (this.cart && this.cart.lastTravel.duration) {
                    return this.formatDuration(this.cart.lastTravel.duration)
                }
                return ''
            },
            set(val) {
                if (val) {
                    this.cart.lastTravel.duration = parseInt(this.$moment(val).format('HH')) * 60 + parseInt(this.$moment(val).format('mm'))
                    this.$emit('update-cart-settings', this.cart)
                }
            }
        },
        departureTime: {
            get() {
                if (this.cart) {
                    return this.cart.departureTime
                }
                return ''
            },
            set(val) {
                const formattedValue = this.$moment(val).format('HH:mm')
                if (formattedValue && formattedValue !== this.cart.departureTime) {
                    this.$emit('updating')
                    this.cart.departureTime = formattedValue
                    this.$emit('update-cart-settings', this.cart)
                }
            }
        },
        date: {
            get() {
                if (this.cart) {
                    return this.cart.date
                }
                return ''
            },
            set(val) {
                const formattedValue = this.$moment(val).format('YYYY-MM-DD')
                if (formattedValue && formattedValue !== this.cart.date) {
                    this.$emit('updating')
                    this.cart.date = formattedValue
                    this.$emit('get-new-cart', this.cart)
                }
            }
        },
        technician: {
            get() {
                if (this.cart) {
                    return this.cart.technician
                }
                return ''
            },
            set(val) {
                if (val && val !== this.cart.technician) {
                    this.$emit('updating')
                    this.cart.technician = val
                    this.$emit('get-new-cart', this.cart)
                }
            }
        },
        hasLunchBreak() {
            return this.cart.interventions.find(item => item.lunchBreak)
        },
        totalTravelTime() {
            let timeAround = (this.cart.firstTravel.duration ?? this.cart.firstTravel.calculatedDuration) + (this.cart.lastTravel.duration ?? this.cart.lastTravel.calculatedDuration)
            let timeBetween = 0
            this.cart.interventions.forEach((item) => {
                if(item.position !== 0) {
                    timeBetween+= item.timeFrom
                }
            })
            return {
                intervention: this.hoursAndMinutes(timeBetween),
                technician: this.hoursAndMinutes(timeAround)
            }
        },
        totalInterventionDuration() {
            let duration = 0
            this.cart.interventions.forEach((item) => {
                duration+= item.intervention.duration
            })
            return this.hoursAndMinutes(duration)
        },
        dateIsSunday() {
            return this.$moment(this.cart.date).isoWeekday() === 7
        },
        computedAbsences() {
            return this.plannedDay.absences ? this.plannedDay.absences.filter(o => o.absence_type_id !== 7).map(o => o.absence_type.name).join(', ') : null
        },
        classComputedAbsences() {
            const lastIndex = this.plannedDay.absences.length - 1
            return {
                'bg-absence-1': this.plannedDay.absences[lastIndex].absence_type_id === 1,
                'bg-absence-2': this.plannedDay.absences[lastIndex].absence_type_id === 2,
                'bg-absence-3': this.plannedDay.absences[lastIndex].absence_type_id === 3,
                'bg-absence-4': this.plannedDay.absences[lastIndex].absence_type_id === 4,
                'bg-absence-5': this.plannedDay.absences[lastIndex].absence_type_id === 5,
                'bg-absence-6': this.plannedDay.absences[lastIndex].absence_type_id === 6,
            }
        },
        computedMeetings() {
            return this.plannedDay.absences ? this.plannedDay.absences.filter(o => o.absence_type_id === 7).map(o => this.$moment(o.date_start).format('HH:mm') + ' - ' + this.$moment(o.date_end).format('HH:mm')).join(', ') : null
        }
    }
}
</script>

<style scoped lang="scss">
.md-layout.md-gutter {
    margin: 0;
    &.disabled-row {
        background-color: $body-bg;
    }
    .md-layout-item {
        padding: 0 10px;

        &:first-child {
            padding-left: 0;
        }

        &:last-child {
            padding-right: 0;
        }
    }
}

.travel-time-background {
    border-radius: 6px 6px 0 0;
    background-color: $cyan-200;
    &.travel-transparent {
        background-color: transparent;
    }
    &.last {
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
        -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
    }
}

.scheduled-day-absence {
    border-radius: 3px;
    padding: .15rem .5rem;

    &.bg-absence-1 {
        background: $gray-lighter-2;
    }
    &.bg-absence-2 {
        background: $cyan-100;
    }
    &.bg-absence-3 {
        background: $orange-100;
    }
    &.bg-absence-4 {
        background: $green-100;
    }
    &.bg-absence-5 {
        background: $red-200;
    }
    &.bg-absence-6 {
        background: $purple-100;
    }
    &.bg-absence-7 {
        background: $pink-100;
    }
}

.conflict {
    line-height: 1;

    .md-icon {
        min-width: 15px;
        height: 15px;
        font-size: 15px !important;
    }
}
.scheduled-day-row {
    .md-icon {
        min-width: 18px;
        height: 18px;
        font-size: 18px !important;
    }

}
</style>
